export const GET_ADMIN_DASHBOARD_DATA_REQUEST =
  "get_admin_dashboard_data_request";
export const GET_ADMIN_DASHBOARD_DATA_RESPONSE =
  "get_admin_dashboard_data_response";
